import makeStateFilter from '../../../make-state-filter';

import { stateFilter as parentStateFilter } from '../bulk.reducer.metadata';

const namespace = 'update';
const stateFilter = makeStateFilter(parentStateFilter, namespace);

export { namespace, stateFilter };
